import React from 'react';
import { Separator } from '@/Components/shadcn/separator';
import BaseTestCardTagItem from './BaseTestCardTagItem';
import BaseTestCardsConstants from './BaseTestCardConstants';
import TestInfo from '../../../../../../../../../Models/TestInfo';
import { getTopicsDescriptionHeaderByTestType } from '../../../../../../../../../Utils/RecommendationStepUtils';

export interface BaseTestCardTagCloudProps extends Pick<TestInfo, 'testType' | 'topics' | 'totalTopicsCount'> {}

function BaseTestCardTagCloud({ topics, totalTopicsCount, testType }: BaseTestCardTagCloudProps): React.JSX.Element {
    return (
        <div className="flex flex-col gap-2.5 px-1.5">
            <div className="text-foreground flex max-h-10 min-h-10 items-center text-xs font-bold tracking-wide">
                {getTopicsDescriptionHeaderByTestType(totalTopicsCount, testType)}
            </div>

            <Separator />

            <div className="flex flex-col content-start justify-between gap-1">
                {topics.slice(0, BaseTestCardsConstants.MaxTagCount).map((item) => (
                    <BaseTestCardTagItem key={item} label={item} />
                ))}
            </div>
        </div>
    );
}

export default BaseTestCardTagCloud;
